module.exports = __webpack_public_path__ + "media/images/products/wedding/img-compensation-case4-e5a6b47058f753aaa745784065459950.png";